// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__14Wb_","selected":"Chip_selected__2dqxf"};